import { useTranslator } from '@bluebeam/react-i18n';
import BaseTextarea from 'components/inputs/BaseTextarea';
import Label from 'components/inputs/Label';
import React, { ReactElement } from 'react';

interface Props {
  editable: boolean;
  value: string;
  onChange: (evt: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const Description = (props: Props): ReactElement => {
  const { editable, value, onChange } = props;
  const { translate } = useTranslator(['mapView']);

  return (
    <div>
      <Label label={translate('mapView:labels.description')} />
      {editable ? (
        <BaseTextarea
          id="update-punch-overlay-description-textarea"
          className="w100"
          rows={6}
          value={value}
          onChange={onChange}
        />
      ) : (
        <div className="font-size-5 light mt2">{value}</div>
      )}
    </div>
  );
};

export default Description;
